import type { SavedTargetingsManager } from '@/state/experiments/useSavedTargetings';
import { LoadSavedTargetingDialog } from './LoadSavedTargetingDialog';
import { SaveTargetingDialog } from './SaveTargetingDialog';
import { SavedTargetingMenu } from './SavedTargetingMenu';

export { TargetingSourceLine } from './TargetingSourceLine';

type SavedTargetingProps = { manager: SavedTargetingsManager };

/** The "Saved targeting" menu for the card header, and whichever of its dialogs is open. */
export const SavedTargeting = ({ manager }: SavedTargetingProps) => {
  if (!manager.canEdit) return null;
  const { dialog } = manager;

  return (
    <>
      <SavedTargetingMenu manager={manager} />
      {dialog?.kind === 'save' ? <SaveTargetingDialog manager={manager} initialMode={dialog.mode} /> : null}
      {dialog?.kind === 'load' ? (
        <LoadSavedTargetingDialog manager={manager} preselectedId={dialog.preselectedId} />
      ) : null}
    </>
  );
};
